export enum RecordTypes {
    MANUAL,
    GAUDE,
    CONTINUOUS_FORMATION
  }
  